import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { position, rgba } from 'polished';
import { connect } from 'react-redux';
import { color, size, media, getLayer } from '@deerplusofficial/pos-helper';
import { ButtonBase as Button } from '@deerplusofficial/pos-components';
import actions from '../../actions';
import Image from '../Image/Image';
import { productShape } from '../../model/Types';

const ProductInner = styled.div`
  display: flex;
  align-items: center;
  height: 68px;
  font-size: 16px;
  ${media(
    'tablet',
    css`
      height: 100%;
      text-align: center;
      position: relative;
    `
  )};
`;

const Container = styled(Button)`
  width: 100%;
  text-align: left;
  border-bottom: 1px solid ${color.border};
  &:last-child {
    border-bottom-width: 0;
  }
  &:disabled {
    pointer-events: none;
    ${ProductInner} {
      opacity: 0.3;
    }
  }
  &:active {
    color: inherit;
    background-color: ${rgba(color.primary, 0.1)};
  }
  ${media(
    'tablet',
    css`
      margin: 0 ${size.productGap} ${size.productGap} 0;
      width: 140px;
      height: 140px;
      vertical-align: middle;
      overflow: hidden;
      border: 1px solid ${color.border};
      border-radius: 6px;
      background-color: ${color.background.light};
      &:active {
        border-color: ${color.primary};
      }
      &:last-child {
        border-bottom-width: 1px;
      }
    `
  )};
`;

const Info = styled.div`
  flex-grow: 1;
  margin-right: 10px;
  ${media(
    'tablet',
    css`
      margin-right: 0;
    `
  )};
`;

const Quantity = styled.div`
  font-size: 12px;
  color: ${color.text.secondary};
  &::before {
    content: '庫存';
  }
  &::after {
    content: '件';
  }
  ${media(
    'tablet',
    css`
      display: inline-block;
      padding: 0 6px;
      border-radius: 4px;
      background-color: ${color.primary};
      color: #ffffff;
      ${position('absolute', '8px', '8px', null, null)};
      &::before,
      &::after {
        display: none;
      }
    `
  )};
`;

const Photo = styled(Image)`
  margin-right: 10px;
  width: 60px;
  height: 60px;
  ${media(
    'tablet',
    css`
      margin-right: 0;
      width: 100%;
      height: 100%;
    `
  )};
`;

const Name = styled.div`
  ${media(
    'tablet',
    css`
      padding: 4px;
      ${Photo} + ${Info} & {
        font-size: 14px;
        background-color: #ffffff;
        z-index: ${getLayer('base')};
        ${position('absolute', null, '0', '0', '0')};
      }
    `
  )};
`;

class Product extends PureComponent {
  static propTypes = {
    ...productShape,
    openProductModal: PropTypes.func,
  };

  static defaultProps = {
    id: '',
    name: '',
    quantity: 0,
    storage: 0,
    track_quantity: false,
    retail_price: undefined,
    photo: {},
    openProductModal: _.identity,
  };

  onClick = () => {
    const { openProductModal, id: productId } = this.props;
    openProductModal({ productId });
  };

  get quantity() {
    const { storage, quantity } = this.props;

    return storage >= quantity ? storage - quantity : 0;
  }

  get disabled() {
    const { track_quantity, order_when_no_stock } = this.props;

    if (order_when_no_stock) return false;

    return track_quantity && this.quantity <= 0;
  }

  render() {
    const { id, name, photo, track_quantity } = this.props;

    return (
      <Container key={id} onClick={this.onClick} disabled={this.disabled}>
        <ProductInner>
          {photo && <Photo src={photo.url} size={140} alt={name} />}
          <Info>
            <Name>{name}</Name>
            {track_quantity && <Quantity>{this.quantity}</Quantity>}
          </Info>
        </ProductInner>
      </Container>
    );
  }
}

const { open: openProductModal } = actions.productModal;

export default connect(
  null,
  { openProductModal }
)(Product);



// WEBPACK FOOTER //
// ./src/components/ProductLine/Product.js